/** Words for the loading screen; one per phase, never a rotating carousel. */
export const LOADING_TEXT = {
  title: 'Project Pancake',
  preparing: 'Preparing your adventure...',
  gathering: 'Gathering your Pokémon...',
  almost: 'Almost time for an adventure!',
  slow: 'Taking a little longer than usual. Still working on it...',
  failed: "Something didn't load correctly.",
  failedHint: 'Check the connection, then try again.',
  retry: 'Try again',
  reload: 'Reload game',
} as const;

/** No progress for this long and the screen says so (it keeps waiting). */
export const STALL_NOTICE_MS = 15_000;

/**
 * The percent to show, or null for "can't measure" (an indeterminate bar).
 * Rounded down and held at 99 until the work is actually finished, so the
 * number never claims done early.
 */
export function percentLabel(fraction: number | null, done = false): string | null {
  if (done) return '100%';
  if (fraction === null || !Number.isFinite(fraction)) return null;
  const pct = Math.floor(Math.min(Math.max(fraction, 0), 1) * 100);
  return `${Math.min(pct, 99)}%`;
}

/** Bar fill 0..1, or null while indeterminate. */
export function barFraction(fraction: number | null): number | null {
  if (fraction === null || !Number.isFinite(fraction)) return null;
  return Math.min(Math.max(fraction, 0), 1);
}

export function isStalled(lastProgressAt: number, now: number, threshold = STALL_NOTICE_MS): boolean {
  return now - lastProgressAt >= threshold;
}

/**
 * Low particle quality (or the OS's reduced motion) keeps the loading sky
 * still. Reads the saved settings directly: the game isn't running yet.
 */
export function calmLoading(rawSettings: string | null, prefersReducedMotion: boolean): boolean {
  if (prefersReducedMotion) return true;
  if (!rawSettings) return false;
  try {
    const s = JSON.parse(rawSettings) as { graphics?: { particles?: unknown } };
    return s.graphics?.particles === 'low';
  } catch {
    return false;
  }
}
